import { STATIC_FILES_CDN_ICON_URL, STATIC_FILES_CDN_URL } from 'constant'

export const FloorOutlined = `${STATIC_FILES_CDN_ICON_URL}/rsp_floor_outlined.svg`
export const RentSpreeSoc2CertifiedLogo = `${STATIC_FILES_CDN_ICON_URL}/rsp_soc2_certified_logo.png`
export const SceneOutlined = `${STATIC_FILES_CDN_ICON_URL}/rsp_scene_outlined.svg`
export const WoodFloorOutlined = `${STATIC_FILES_CDN_ICON_URL}/rsp-wood-floor-outlined.svg`
export const CapetFloorOutlined = `${STATIC_FILES_CDN_ICON_URL}/rsp-carpet-floor-outlined.svg`

export const TwitterXIcon = `${STATIC_FILES_CDN_ICON_URL}/twitter_x_icon.svg`

export const PhotoGalleryEmpty = `${STATIC_FILES_CDN_URL}/listing_photo_gallery_empty.png`
